<template>
    <div class="app">
        <Loading :value="loading"></Loading>
        <!-- RACOURCIS -->
        <v-card>
            <v-card-title>
                <v-breadcrumbs icons divider="chevron_right">
                    <v-breadcrumbs-item icons router :to='item.path' v-for="item in racourcis" :key="item.text" :disabled="item.disabled"> {{ item.text }}</v-breadcrumbs-item>
                </v-breadcrumbs>
            </v-card-title>
        </v-card>
        <br/>

            <!--Ligne 1 -->
            <v-layout row >
                <v-card style="width:100%" v-if="droitAcces.index_commande_comparateur">
                    <v-card-text fluid grid-list-md>
                    <h6>LISTE DES COMMANDES ANALYSEES PAR LE COMPARATEUR DE PRIX</h6>
                    <v-divider class="mb-3" ></v-divider>

                    <!-- BTN AJOUT -->
                    <v-layout row>
                           <v-flex class="mb-1 " xs4 md4>
                            <v-card-text class="text-xs-center">
                                <v-chip label outline   color="orange darken-1"  class="elevation-4" style="width:100%">
                                    <span class="subheading">Montant Total  Economisé : </span> <span class="title"> {{beneficeTotal}} Fcfa </span>
                                </v-chip>
                            </v-card-text>
                           </v-flex>

                           <v-flex class="mb-1 " xs4 md4 >
                                <v-card-text class="">
                                <v-chip color="orange" text-color="white" style="font-size:18px">
                                <v-avatar  class="orange darken-4">{{totalCmd}}</v-avatar>
                                Commande(s)
                            </v-chip>
                             </v-card-text>
                           </v-flex>
                    </v-layout>



                    <v-spacer></v-spacer>
                    <div class="text-xs-right mb-3" >
                      <!-- <v-tooltip top>
                        <v-btn  slot="activator" icons color="primary" @click.stop="modalAjoutDmd()" dark>Ajouter une demande <v-icon right>playlist_add</v-icon></v-btn>
                        Effectuer une demande de fonds
                      </v-tooltip> -->

                      <!-- <v-tooltip top>
                            <v-btn   slot="activator" color="orange"  @click.stop="imprimeDemandePDF()" dark>
                                Imprimer
                                <v-icon right > print</v-icon>
                            </v-btn>
                            Imprimer la liste des demandes
                        </v-tooltip> -->
                    </div>

                     <v-layout row >

                    </v-layout>

                     <!-- <div class="text-xs-right " >
                         <el-select clearable @clear="clearSelect()"  @change="filtrerFournisseur" v-model="selectCaisseDmd" placeholder="Selectionner une caisse">
                                <el-option
                                        v-for="item in listeCaisse"
                                        :key="item.id"
                                        :label="item.libelle"
                                        :value="item.id">
                                </el-option>
                            </el-select>

                            <el-select clearable @clear="clearSelect()"  @change="filtrerEtatDmd" v-model="selectEtatDmd" placeholder="Selectionner le statut">
                                <el-option
                                        v-for="item in listeStatut"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                     </div> -->

                    <data-tables :data="listeCommandes"  v-if="droitAcces.index_commande_comparateur">
                        <el-table-column prop="dateCom" label="Date" > </el-table-column>
                        <el-table-column prop="refCmd" label="Date" > </el-table-column>
                        <el-table-column prop="userCreate" label="Initiateur" ></el-table-column>
                        <!-- <el-table-column prop="benefice" label="Gain (Fcfa)" >
                            <template slot-scope="scope">
                                <el-tag  >  {{scope.row.benefice}}</el-tag>
                            </template>
                        </el-table-column> -->
                        <el-table-column prop="fournisseur" label="Fournisseur" > </el-table-column>
                        <el-table-column label="Action" align="center" fixed="right"  >
                        <template slot-scope="scope">
                             <v-tooltip top>
                            <v-btn  slot="activator" @click="modalDetailCmd(scope.row)" fab dark small color="grey">
                                <v-icon dark>list</v-icon>
                                </v-btn>
                                    Detail des commandes générées
                            </v-tooltip>
                            <!-- <v-tooltip top>
                            <v-btn  slot="activator" v-show="scope.row.statut  == 1 "  @click="modalEditDmd(scope.row)" fab dark small color="primary">
                                <v-icon dark>edit</v-icon>
                                </v-btn>
                                    Editer
                            </v-tooltip> -->
                        </template>
                        </el-table-column>
                    </data-tables>
                  </v-card-text>
                </v-card>
            </v-layout>


            <!-- Detail de la commamde initial -->
            <ModalDetailCommande :cmdInit = "cmdInit"  :cmdDerivees = "cmdDerivees"   :show = "showModalDetailCmd" @close="showModalDetailCmd = false" ></ModalDetailCommande>
            <!-- Detail de la commamde initial -->


    </div>
</template>

<script>


    import ModalDetailCommande from '@/components/comparateur/ModalDetailCommande'

    import Loading from '@/components/Loading'
    export default {
        components:{ Loading ,ModalDetailCommande},
        name: "comparateur_index",
        data() {
            return {
                //data general
                notif: JSON.parse(sessionStorage.getItem('sessionNotif')),
                domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
                user: JSON.parse(sessionStorage.getItem('userInfo')),
                roleAcces: JSON.parse(sessionStorage.getItem('sessionAcces')),
                droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),
                loading: false,
                racourcis: [
                    { path: '/', text: 'Accueil', disabled: false },
                    { path: '/demandeFond', text: 'Demande de fonds', disabled: true }
                ],

                listeCommandes: [],
                beneficeTotal: 0,
                mntTotal: 0,
                totalCmd : 0 ,
                cmdDerivees: [],
                cmdInit: [],
                showModalDetailCmd: false,

            }
        },

        methods: {

        // imprimeDemandePDF()
        // {
        //     let tab = [];
        //     this.listeDemandes.forEach(function(demande) {
        //          tab.push(demande.id)
        //     });

        //       let  url = this.domaine+"demandeFond/imprimerPDF/liste/"+tab
        //      window.open(url)

        // },



             loadCommande()
             {
                 this.loading = true;
                 let url = this.domaine +  'comparateur/commande/index';

                this.$http.get(url ).then(response => {
                  this.loading = false;

                 // this.mntTTC =  response.body.mntTTC
                  this.listeCommandes = response.body.commandes
                  this.beneficeTotal = response.body.beneficeTotalFormat;

                  //affichage nombre de demande
                  this.totalCmd = this.listeCommandes.length
                },
                response => {
                    this.loading = false;
                     this.$message.error("Une erreur est survenue lors du chargement des commandes")

                })
            },

            modalDetailCmd(item)
            {
                this.loading = true;

                const idComInit = item.idCmdInit;
                let url = this.domaine + "comparateur/commande/initial/"+idComInit;
                this.$http.get(url).then(
                    resp => {
                        console.log( resp.body)
                        this.cmdDerivees = resp.body.derive,
                        this.cmdInit = resp.body.initial[0]
                        this.showModalDetailCmd = true
                        this.loading = false;
                    },
                    resp => {
                         this.loading = false;
                        this.$message.error(
                            "erreur lors du chargement des details de la commande"
                        );
                    }
                );

            }



        },

        mounted() {
          this.loadCommande();
        }
    };
</script>

<style scoped>
    .toolbar_content {
        height:37px;
    }
</style>



// WEBPACK FOOTER //
// src/components/comparateur/comparateur_index.vue